import React, { Component, useState, useEffect } from 'react';
import '../../../../Utility/Public/css/common.scss';
import '../Assets/css/homedoc.scss';
import '../Assets/css/homeresponsivedoc.scss';
import { loaderStateTrue, loaderStateFalse, selectChooseBranch, userSearchData, groupTourPackageSearchData } from '../../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../../../src/GlobalModules/Login/Actions/LoginAction';
import SkeletonThemeContentGroupList from '../../../../Utility/Components/SkeletonThemeContentGroupList';
import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import CommonDateTimePicker from '../../../../Utility/Components/CommonDateTimePicker';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import { connect } from 'react-redux';
import moment from 'moment';
import { withNamespaces } from 'react-i18next';
import { Country, City } from 'country-state-city';
import Utility from '../../../../Utility/Utility';
import { DebounceInput } from 'react-debounce-input';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { getTourLocationList } from '../Controller/HomeController';

function GroupPackageSearchPanel(props) {
    const history = useHistory();
    const location = useLocation();
    const [selectedFromCity, setSelectedFromCity] = useState(null);
    const [selectedGoingCity, setSelectedGoingCity] = useState(null);
    const [cityList, setCityList] = useState([]);
    const [searchGroupBookingData, setSearchGroupBookingData] = useState("");
    const [filteredCityList, setFilteredCityList] = useState([]);
    const [urlParamsProcessed, setUrlParamsProcessed] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [endDateMinMax, setEndDateMinMax] = useState({
        minDate: new Date(),
        maxDate: new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate() + 1)
    });

    // Process URL parameters and update the component and Redux state
    const processUrlParams = () => {
        if (urlParamsProcessed) return;
        
        const searchParams = new URLSearchParams(location.search);
        const from = searchParams.get('from');
        const to = searchParams.get('to');
        const search = searchParams.get('search');
        const start_date = searchParams.get('start_date');
        const end_date = searchParams.get('end_date');
        
        // Only process if there are URL parameters to handle
        if (from || to || search || start_date || end_date) {
            let updatedSearchData = { ...(props.userGroupTourPackageSearchData || {}) };
            let hasChanges = false;
            
            // Handle from parameter
            if (from) {
                const fromCity = { label: from, value: from };
                setSelectedFromCity(fromCity);
                updatedSearchData.starting_from = fromCity;
                hasChanges = true;
            }
            
            // Handle to parameter
            if (to) {
                const toCity = { label: to, value: to };
                setSelectedGoingCity(toCity);
                updatedSearchData.going_to = toCity;
                hasChanges = true;
            }
            
            // Handle search parameter
            if (search) {
                setSearchGroupBookingData(search);
                updatedSearchData.search = search;
                hasChanges = true;
            }

            // Handle Start Date parameter
            if (start_date) {
                const parsedStartDate = new Date(start_date);
                setStartDate(parsedStartDate);
                updatedSearchData.start_date = parsedStartDate;
                hasChanges = true;
            }

            // Handle end date parameter
            if (end_date) {
                const parsedEndDate = new Date(end_date);
                setEndDate(parsedEndDate);
                updatedSearchData.end_date = parsedEndDate;
                hasChanges = true;
            }
            
            // Update Redux if needed
            if (hasChanges) {
                props.groupTourPackageSearchData(updatedSearchData);
            }
        }
        
        setUrlParamsProcessed(true);
    };

    useEffect(() => {
        const getTourLocationOption = () => {
            getTourLocationList().then((response) => {
                const locations = response?.data || [];
                const formattedCities = locations.map(city => ({
                    label: city.destination_name,
                    value: city.destination_name
                }));
                setCityList(formattedCities);
            }).catch((error) => {
                console.error("Tour location list error", error);
            });
        };
        getTourLocationOption();
        
        // Process URL parameters when component mounts
        processUrlParams();
    }, []);
    
    // Process URL parameters when they change
    // Listen for URL parameter changes and process them
    useEffect(() => {
        // Reset the flag when location.search changes to force re-processing
        if (location.search) {
            setUrlParamsProcessed(false);
        }
        
        if (!urlParamsProcessed) {
            processUrlParams();
        }
    }, [location.search]);

    const handleOnInputChange = (inputValue) => {
        if (inputValue.length >= 2) {
            const filtered = cityList.filter(city =>
                city.label.toLowerCase().includes(inputValue.toLowerCase())
            );
            setFilteredCityList(filtered);
        } else {
            setFilteredCityList([]);
        }
    };

    const buildTourQueryString = (searchData) => {
        const searchParams = new URLSearchParams();
        if (searchData.starting_from?.value) {
            searchParams.set('from', searchData.starting_from.value);
        }
        if (searchData.going_to?.value) {
            searchParams.set('to', searchData.going_to.value);
        }
        if (searchData.search) {
            searchParams.set('search', searchData.search);
        }
        if (searchData.start_date) {
            const formatted = moment(searchData.start_date).format('YYYY-MM-DD');
            if (formatted && formatted !== 'Invalid date') {
                searchParams.set('start_date', formatted);
            }
        }
        if (searchData.end_date) {
            const formatted = moment(searchData.end_date).format('YYYY-MM-DD');
            if (formatted && formatted !== 'Invalid date') {
                searchParams.set('end_date', formatted);
            }
        }
        return searchParams.toString();
    };

    const handleChange = (inputValue, type) => {
        // We don't want to process URL params after manual user input
        // to avoid overriding user's selections

        const searchReducerData = props.userGroupTourPackageSearchData || {};
        let tempSearchReducerData = { ...searchReducerData };

        const isCleared = !inputValue || (Array.isArray(inputValue) && !inputValue.some(Boolean));
        if (isCleared) {
            if (type === "starting_from") {
                setSelectedFromCity(null);
                setSelectedGoingCity(null);
                props.setGroupTourState && props.setGroupTourState([]);
                tempSearchReducerData = { ...searchReducerData, starting_from: "", going_to: "" };
            }
            if (type === "going_to") {
                setSelectedGoingCity(null);
                props.setGroupTourState && props.setGroupTourState([]);
                tempSearchReducerData = { ...searchReducerData, going_to: "" };
            }
            if (type === "date") {
                setStartDate(null);
                setEndDate(null);
                setEndDateMinMax({
                    minDate: new Date(),
                    maxDate: new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate() + 1)
                });
                tempSearchReducerData = { ...searchReducerData, start_date: "", end_date: "" };
            }
            props.groupTourPackageSearchData(tempSearchReducerData);

            const queryString = buildTourQueryString(tempSearchReducerData);
            if (props.callFrom === "tour-list") {
                const targetUrl = `${location.pathname}${queryString ? `?${queryString}` : ''}`;
                if (targetUrl !== `${location.pathname}${location.search}`) {
                    history.replace(targetUrl);
                }
                if (props.getGroupTour) {
                    setTimeout(() => props.getGroupTour(1, tempSearchReducerData), 0);
                }
            } else if (props.callFrom === "tour-details") {
                history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/tour-list${queryString ? `?${queryString}` : ''}`);
            }
            return;
        }

        if (type === "starting_from") {
            setSelectedFromCity(inputValue);
            tempSearchReducerData = { ...searchReducerData, starting_from: inputValue };
            props.groupTourPackageSearchData(tempSearchReducerData);
        }
        if (type === "going_to") {
            setSelectedGoingCity(inputValue);
            tempSearchReducerData = { ...searchReducerData, going_to: inputValue };
            props.groupTourPackageSearchData(tempSearchReducerData);
        }

        if (type === "date") {
            if (inputValue) {
                let [start, end] = inputValue;
                if (end && start.getTime() === end.getTime()) {
                    return;
                }

                if (start) {
                    const maxDate = new Date(start);
                    maxDate.setDate(maxDate.getDate() + 30);

                    setEndDateMinMax({
                        minDate: start,
                        maxDate: maxDate
                    });

                    if (end) {
                        const endTime = end.getTime();
                        if (endTime < start.getTime() || endTime > maxDate.getTime()) {
                            end = null;
                        }
                    }
                }

                setStartDate(start);
                setEndDate(end);

                tempSearchReducerData = { ...searchReducerData, start_date: start, end_date: end };
                props.groupTourPackageSearchData(tempSearchReducerData);
            }
        }

        if (props.callFrom === "tour-list") {
            const queryString = buildTourQueryString(tempSearchReducerData);
            const targetUrl = `${location.pathname}${queryString ? `?${queryString}` : ''}`;
            if (targetUrl !== `${location.pathname}${location.search}`) {
                history.replace(targetUrl);
            }
        }

        if (
            props.callFrom === "tour-details" &&
            (
                (type === "starting_from" && inputValue?.value?.trim()) ||
                (type === "going_to" && inputValue?.value?.trim()) ||
                (type === "date" && inputValue && inputValue[0])
            )
        ) {
            const queryString = buildTourQueryString(tempSearchReducerData);
            history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/tour-list${queryString ? `?${queryString}` : ''}`);
        }
    };

    const handleSearchValue = (e) => {
        const value = e.target.value;
        setSearchGroupBookingData(value);
        
        // We don't want to process URL params after manual user input
        // to avoid overriding user's selections
        
        // Update Redux state with the search text
        let searchReducerData = props.userGroupTourPackageSearchData || {};
        let tempSearchReducerData = {
            ...searchReducerData,
            search: value,
        };
        props.groupTourPackageSearchData(tempSearchReducerData);
        
        // If on tour-details page and search has content, navigate to tour-list
        if (props.callFrom === "tour-details" && value?.trim()) {
            // Build URL with current filters when navigating
            const searchParams = new URLSearchParams();
            
            // Include the updated filters
            const updatedSearchData = {
                ...props.userGroupTourPackageSearchData,
                search: value
            };
            
            if (updatedSearchData.starting_from?.value) {
                searchParams.set('from', updatedSearchData.starting_from.value);
            }
            
            if (updatedSearchData.going_to?.value) {
                searchParams.set('to', updatedSearchData.going_to.value);
            }
            
            if (value?.trim()) {
                searchParams.set('search', value);
            }

            if (updatedSearchData.start_date) {
                searchParams.set('start_date', moment(updatedSearchData.start_date).format('YYYY-MM-DD'));
            }

            if (updatedSearchData.end_date) {
                searchParams.set('end_date', moment(updatedSearchData.end_date).format('YYYY-MM-DD'));
            }
            
            const queryString = searchParams.toString();
            history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/tour-list${queryString ? `?${queryString}` : ''}`);
        } else if (props.getGroupTour && props.callFrom === "tour-list") {
            // If already on tour-list page, trigger search with page reset after a small delay
            setTimeout(() => props.getGroupTour(1), 300); 
        }
    };

    const clearSearchValue = () => {
        setSearchGroupBookingData("");
        
        // We don't want to process URL params after manual user input
        // to avoid overriding user's selections
        
        // Update Redux state - clear search text
        let searchReducerData = props.userGroupTourPackageSearchData || {};
        let tempSearchReducerData = {
            ...searchReducerData,
            search: "",
        };
        props.groupTourPackageSearchData(tempSearchReducerData);
        
        // Trigger a new search if we're on the tour list page
        if (props.getGroupTour && props.callFrom === "tour-list") {
            setTimeout(() => props.getGroupTour(1), 0);
        }
    }

    useEffect(() => {
        // console.log("selectedFromCity=======", selectedFromCity)
        // console.log("selectedGoingCity=======", selectedGoingCity)
    }, [selectedFromCity, selectedGoingCity])

    const handleBlur = () => {
        if (props.is_fixed_date) return;
        if (startDate && !endDate) {
            const nextDay = new Date(startDate);
            nextDay.setDate(nextDay.getDate() + 1);

            const maxAllowedEndDate = new Date(startDate);
            maxAllowedEndDate.setDate(maxAllowedEndDate.getDate() + 30);

            const end = nextDay <= maxAllowedEndDate ? nextDay : maxAllowedEndDate;
            handleChange([startDate, end], 'date');
        }
    };

    const isDateDisabled = !!props.is_fixed_date;

    useEffect(() => {
        if (props.is_fixed_date && props.start_date && props.end_date) {
            const start = new Date(props.start_date);
            const end = new Date(props.end_date);
            setStartDate(start);
            setEndDate(end);
            setEndDateMinMax({
                minDate: start,
                maxDate: end,
            });
            let searchReducerData = props.userGroupTourPackageSearchData || {};
            props.groupTourPackageSearchData({
                ...searchReducerData,
                start_date: start,
                end_date: end,
            });
        }
    }, [props.is_fixed_date, props.start_date, props.end_date]);

    useEffect(() => {
        if (!props.is_fixed_date && !startDate && props.userGroupTourPackageSearchData?.start_date) {
            const start = new Date(props.userGroupTourPackageSearchData.start_date);
            if (!isNaN(start.getTime())) {
                setStartDate(start);
                if (props.userGroupTourPackageSearchData?.end_date) {
                    const end = new Date(props.userGroupTourPackageSearchData.end_date);
                    if (!isNaN(end.getTime())) {
                        setEndDate(end);
                    }
                }
            }
        }
    }, [props.userGroupTourPackageSearchData?.start_date, props.userGroupTourPackageSearchData?.end_date, props.is_fixed_date]);

    const handleSearchClick = () => {
        let searchData = props.userGroupTourPackageSearchData || {};
        if (startDate && !searchData.start_date) {
            searchData = { ...searchData, start_date: startDate, end_date: endDate };
            props.groupTourPackageSearchData(searchData);
        }
        const queryString = buildTourQueryString(searchData);

        if (props.callFrom === "tour-details") {
            history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/tour-list${queryString ? `?${queryString}` : ''}`);
        } else if (props.callFrom === "tour-list") {
            const targetUrl = `${location.pathname}${queryString ? `?${queryString}` : ''}`;
            if (targetUrl !== `${location.pathname}${location.search}`) {
                history.replace(targetUrl);
            }
            if (props.getGroupTour) {
                props.getGroupTour(1, searchData);
            }
        } else {
            if (props.getGroupTour) {
                props.getGroupTour(1, searchData);
            }
        }
    };

    const isSearchDisabled =
        (!selectedFromCity || !selectedFromCity.value?.trim()) &&
        (!startDate || !endDate);
        
    return (
        <>
            <div className='searchPanel searchPanelInner hotel-group-package-tour-box'>
                <div className='container'>
                    <div className='inner-container'>
                        <div className='col-md-12'>
                            <div className='row package-tour-boxes'>
                                <div className='col-md-3 col-sm-6'>
                                    <ErrorBoundary title="CustomInput Error">
                                        <div className="dropdowninnerbox">
                                            <AutosuggestComponent
                                                handleOnChange={(e) => handleChange(e, 'starting_from')}
                                                handleOnInputChange={handleOnInputChange}
                                                options={filteredCityList.length > 0 ? filteredCityList : cityList}
                                                selectedValue={props.userGroupTourPackageSearchData != undefined && Object.keys(props.userGroupTourPackageSearchData).length > 0 && props.userGroupTourPackageSearchData.hasOwnProperty('starting_from') && props.userGroupTourPackageSearchData.starting_from && Object.keys(props.userGroupTourPackageSearchData.starting_from).length > 0 ? props.userGroupTourPackageSearchData.starting_from : ""}
                                                isMulti={false}
                                                placeholder="Location"
                                                isDisabled={false}
                                                isSearchable={true}
                                                classNamePrefix="dropdown-default"
                                                isClearable={true}
                                            />
                                        </div>
                                    </ErrorBoundary>
                                </div>
                                <div className='col-md-4 col-sm-6'>
                                    <div className='datePickerBoxCover'>
                                        <div className='datePickerBoxes'>
                                            {startDate != null ?
                                                <div className='datepickerBox'>
                                                    <strong>{startDate.getDate()}</strong>
                                                    <p>{Utility.getMonthName(startDate.getMonth())}, {startDate.getFullYear()} <span>Start Date</span></p>
                                                </div> :
                                                <div className='datepickerBox'>
                                                    <strong></strong>
                                                    <p><span>Start Date</span></p>
                                                </div>}
                                            {endDate != null ?
                                                <div className='datepickerBox'>
                                                    <strong>{endDate.getDate()}</strong>
                                                    <p>{Utility.getMonthName(endDate.getMonth())}, {endDate.getFullYear()} <span>End Date</span></p>
                                                </div> :
                                                <div className='datepickerBox'>
                                                    <strong></strong>
                                                    <p><span>End Date</span></p>
                                                </div>}
                                        </div>
                                        <div className='search-panel-slider-box choosedateSearch'>
                                            <ErrorBoundary title="CommonDateTimePicker Error">
                                                <CommonDateTimePicker
                                                    dateRange={true}
                                                    selected={startDate}
                                                    onChange={(e) => handleChange(e, 'date')}
                                                    onBlur={handleBlur}
                                                    startDate={startDate}
                                                    endDate={endDate}
                                                    selectsRange={true}
                                                    isClearable={!isDateDisabled}
                                                    disabled={isDateDisabled}
                                                    placeholderText="Start and End Date"
                                                    minDate={new Date()}
                                                    maxDate={startDate ? endDateMinMax.maxDate : new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate() + 1)}
                                                    dateFormat={!endDate ? "E d MMM" : "E d MMM"}
                                                    placement="bottom"
                                                />
                                            </ErrorBoundary>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className='col-md-4 col-sm-8 tag-search-box'>
                                    <div className='search-input-group'>
                                        <div className="pageinnersearch searchBox">
                                            <button type="button" className="btn btn-link search_btn_addon">
                                                <img className="searchicon" src={require('../../../../Utility/Public/images/searchicon1.png')} />
                                            </button>
                                            <DebounceInput
                                                minLength={2}
                                                debounceTimeout={500}
                                                onChange={(e) => handleSearchValue(e)}
                                                placeholder="Tag or keyword (e.g., Temple, Beach, Luxury)"
                                                value={props.userGroupTourPackageSearchData != undefined && Object.keys(props.userGroupTourPackageSearchData).length > 0 && props.userGroupTourPackageSearchData.hasOwnProperty('search') && props.userGroupTourPackageSearchData.search && props.userGroupTourPackageSearchData.search ? props.userGroupTourPackageSearchData.search : ""}
                                            />
                                            {props.userGroupTourPackageSearchData != undefined && Object.keys(props.userGroupTourPackageSearchData).length > 0 && props.userGroupTourPackageSearchData.hasOwnProperty('search') && props.userGroupTourPackageSearchData.search && props.userGroupTourPackageSearchData.search != "" ?
                                                < button type="button" className="btn btn-link dropclosebtn"
                                                    onClick={clearSearchValue}
                                                >
                                                    <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-tj5bde-Svg searchClearIcon"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg>
                                                </button>
                                                : null}
                                        </div>
                                    </div>
                                </div> */}
                                <div className='col-md-2 paddingL0'>
                                    <button type='button' className={`search-button ${isSearchDisabled ? 'disabled-button' : ''}`} onClick={handleSearchClick}><i className="fa fa-search" aria-hidden="true"></i> Search</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

GroupPackageSearchPanel.defaultProps = {
    callFrom: ""
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        userSearchDataFromReducer: globalState.mainReducerData.userSearchData,
        userGroupTourPackageSearchData: globalState.mainReducerData.groupTourPackageSearchData,
    };
}


export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setUserCredentials, logOutApp, userSearchData, setToken, groupTourPackageSearchData })(GroupPackageSearchPanel);
